export const PO_URL = 'report/po'
export const PO_ERROR = 'PO_ERROR'
export const PO_LOADING = 'PO_LOADING'
export const PO_SUCCESS = 'PO_SUCCESS'